import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { WidgetProps } from '@/lib/widgets/types';
import { Plus, FileText, Car, HeadphonesIcon } from 'lucide-react';

export function QuickActionsWidget({ isEditing = false }: WidgetProps) {
  const actions = [
    { label: 'Nova NFe', icon: FileText, action: () => console.log('Nova NFe'), color: 'bg-blue-500 hover:bg-blue-600' },
    { label: 'Novo Veículo', icon: Car, action: () => console.log('Novo Veículo'), color: 'bg-green-500 hover:bg-green-600' },
    { label: 'Novo Chamado', icon: HeadphonesIcon, action: () => console.log('Novo Chamado'), color: 'bg-purple-500 hover:bg-purple-600' },
    { label: 'Adicionar', icon: Plus, action: () => console.log('Adicionar'), color: 'bg-orange-500 hover:bg-orange-600' }
  ];

  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle className="text-sm font-medium">Ações Rápidas</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {actions.map((action, index) => (
          <Button
            key={index}
            variant="outline"
            className="w-full justify-start gap-2 h-auto py-3"
            onClick={action.action}
            disabled={isEditing}
          >
            <action.icon className="h-4 w-4" />
            {action.label}
          </Button>
        ))}
      </CardContent>
    </Card>
  );
}